<template>
  <div v-if="links.length > 3">
    <div class="flex flex-wrap -mb-1">
      <template v-for="(link, key) in links">
        <div v-if="link.url === null" :key="key" class="mr-1 mb-1 px-4 py-3 text-sm leading-4 text-gray-400 border rounded" v-html="link.label" />
        <Link v-else :key="link.url" class="mr-1 mb-1 px-4 py-3 text-sm leading-4 border rounded hover:bg-white focus:border-black-500 focus:text-black-500" :class="{ 'bg-white': link.active }" :href="returnLink(link)" v-html="link.label"></Link>
      </template>
    </div>
  </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";

export default {
  props: {
    links: Array,
    pagination : String,
    search : String
  },
  components : {
    Link
  },
  methods : {
    returnLink(link){
      if(this.search==null){
        var search = ''
      }else {
        var search = this.search
      }
      return link.url +  '&pagination=' + this.pagination + '&search=' + search
    }
  }
}
</script>